// Utility functions for formatting property data

const normalizeSizeUnit = (sizeUnit) => {
  const raw = String(sizeUnit || '').trim().toLowerCase();
  if (!raw) return '';
  const map = {
    'sqft': 'sq_ft',
    'ft2': 'sq_ft',
    'sq_ft': 'sq_ft',
    'sqm': 'sq_m',
    'm2': 'sq_m',
    'm²': 'sq_m',
    'sq_m': 'sq_m',
    'acre': 'acre',
    'acres': 'acre',
    'hectare': 'hectare',
    'hectares': 'hectare',
    'hectars': 'hectare',
    'ha': 'hectare',
    'sq_mi': 'sq_mi',
    'sqmi': 'sq_mi',
    'sq_km': 'sq_km',
    'sqkm': 'sq_km',
    'km2': 'sq_km',
  };
  return map[raw] || raw;
};

/** Form dropdown values on PropertyReportPage (sqm | acres | hectares). */
export const normalizeLotUnitForForm = (unit) => {
  const text = String(unit ?? '').trim().toLowerCase();
  if (!text) return 'sqm';
  if (text.includes('hect') || text === 'ha') return 'hectares';
  if (text.includes('acre')) return 'acres';
  return 'sqm';
};

/** Admin / verification dropdown values (sq_m | sq_ft | acres | hectares). */
export const normalizeLotUnitForAdmin = (unit) => {
  const text = String(unit ?? '').trim().toLowerCase();
  if (!text) return 'sq_m';
  if (text.includes('hect') || text === 'ha') return 'hectares';
  if (text.includes('acre')) return 'acres';
  if (text.includes('ft')) return 'sq_ft';
  return 'sq_m';
};

/** Canonical unit stored in the API (sq_m | sq_ft | acre | hectare). */
export const mapLotUnitForBackend = (unit) => {
  const text = String(unit ?? '').trim().toLowerCase();
  if (text === 'acres' || text === 'acre') return 'acre';
  if (text === 'hectares' || text === 'hectare' || text === 'ha' || text === 'hectars') return 'hectare';
  if (text === 'sq_ft' || text === 'sqft' || text === 'ft2') return 'sq_ft';
  return 'sq_m';
};

export const formatSizeUnit = (sizeUnit) => {
  const unitMap = {
    'sq_ft': 'ft²',
    'sq_m': 'm²',
    'acre': 'acres',
    'sq_mi': 'sq mi',
    'sq_km': 'km²',
    'hectare': 'hectares',
  };
  const normalized = normalizeSizeUnit(sizeUnit);
  return unitMap[normalized] || (normalized || 'm²');
};

export const formatSize = (size, sizeUnit) => {
  if (!size) return '';
  // When backend omits size_unit, default to sq_m so we never show wrong unit (e.g. hectares)
  const unit = sizeUnit ?? 'sq_m';
  return `${size.toLocaleString()} ${formatSizeUnit(unit)}`;
};

export const formatPrice = (price, currency = 'USD') => {
  if (!price) return '';
  return `${currency} ${price.toLocaleString()}`;
};
